const Devices = () => import("Modules/devices/views/Devices");
const DevicesForm = () => import("Modules/devices/views/DevicesForm");
const DevicesMonitor = () => import("Modules/devices/views/Monitor");

export default {
    children: [
        {
            path: "devices",
            name: "devices",
            component: Devices,
            meta: {
                requiresAuth: true,
                title: "lang.devices",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "d_acct_mgr",
                    "customer",
                    "distributor",
                    "customer_readonly",
                ],
                restrict_by_permission: ["devices.read"],
            },
        },
        {
            path: "devices/profile/:id?",
            name: "device",
            component: DevicesForm,
            meta: {
                requiresAuth: true,
                title: "lang.devices",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "d_acct_mgr",
                    "customer",
                    "distributor",
                    "customer_readonly",
                ],
                restrict_by_permission: ["devices.read"],
            },
        },
        {
            path: "devices/monitor/:id(\\d+)",
            name: "devices_monitor",
            component: DevicesMonitor,
            meta: {
                requiresAuth: true,
                title: "lang.monitor_device",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["devices.read"],
            },
        },
    ],
};
